//import bFormInput from 'bootstrap-vue/src/components/form-input/form-input';
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input'

var pyFormInput = {
  name: 'pyFormInput',
  extends: bFormInput,
  methods:{
    focus: function(e){
      this.$parent.$emit('pyInputFocus', e.target);
    },
    blur: function(e){
      this.$parent.$emit('pyInputBlur', e.target);
    }
  },
  mounted: function(){
    this.$el.addEventListener("focus", this.focus)
    this.$el.addEventListener("blur", this.blur)
  }
}

export default pyFormInput;
